// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"baae6c61","4268":"e95aa917","7848":"2d61f04a","9985":"2c90259a"}[chunkId] + ".chunk.css";
};